import React, {Fragment, useContext, useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {isEmpty} from "../Utils";
import {toggleModal} from "../../actions/modal.action";
import {getCustomer} from "../../actions/stripe.action";
import Checkbox from "react-custom-checkbox";
import EditPayment from "../account/subscription/submenu/EditPayment";
import {MyContext} from "../../contexts/MyContext";
import PriceSelector from "../stripe/PriceSelector";

const NavBarMobileSubscriptionPlans = (props) => {
    const setTypeMenu = props.setTypeMenu;
    const { createSubscribe } = useContext(MyContext);
    const dispatch = useDispatch();
    const settings = useSelector((state) => state.settingReducer.getSettingReducer.config);
    const stripeReducer = useSelector((state) => state.stripeReducer);
    const customer = stripeReducer.getCustomerReducer;
    const products = stripeReducer.getProductsReducer;
    const activePlan = stripeReducer.getActiveCustomerProductReducer;
    const translationsReducer = useSelector(
        (state) => state.langReducer.translationsReducer
    );
    const translations = translationsReducer.translate;
    const [checkedPlanId, setCheckedPlanId] = useState(null);
    const [checkedPriceId, setCheckedPriceId] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [prices, setPrices] = useState([]);
    const [wait, setWait] = useState(false);
    const [openEditPayment, setOpenEditPayment] = useState(false);
    const [customerPlan, setCustomerPlan] = useState(false);

    useEffect(() => {
        if (!isEmpty(activePlan)) {
            setCustomerPlan(activePlan)
        }
    }, [activePlan]);

    useEffect(() => {
        if (openModal && products) {
            products.forEach((product) => {
                if (product.id === checkedPlanId) {
                    const newArrayOfObj = product.prices.map((item) => {
                        return {value: item.id, label: (item.unit_amount / 100).toLocaleString('eu-EU', {style: 'currency',currency: 'EUR'}) + "/" + (!isEmpty(item?.recurring?.interval) ? item.recurring.interval : "one time"), ...item };
                    });
                    setPrices(newArrayOfObj);
                }
            })
        }
    }, [checkedPlanId, openModal, products]);

    const onChangePlan = async () => {
        if (!isEmpty(customer.id) && !isEmpty(checkedPriceId)) {
            setWait(true);
            let paymentResult = await createSubscribe(customer.id, checkedPriceId);

            setOpenModal(false);

            if (paymentResult.result) {
                if (paymentResult.result === "empty_payments_methods") {

                    setOpenEditPayment(true);

                } else if (paymentResult.result !== "succeeded" && paymentResult.result !== "ok") {
                    dispatch(toggleModal(
                        {
                            opened: true,
                            success: false,
                            text: !isEmpty(paymentResult.error) ? paymentResult.error : "Subscribe error"
                        })
                    )

                } else {
                    dispatch(getCustomer());

                    dispatch(toggleModal(
                        {
                            opened: true,
                            success: true,
                            text: "Subscribe success"
                        })
                    )
                }
            } else {
                dispatch(toggleModal(
                    {
                        opened: true,
                        success: false,
                        text: "Subscribe error"
                    })
                )
            }
            setWait(false)
        } else {
            console.log("error")
        }

    }

    return (
        <Fragment>

            <div className="parameters-container">
                <div className="parameters-title">
                    <div className="title" style={{background: !isEmpty(settings) ? settings.accent_color : ""}}>
                        <h1>
                            <span onClick={() => setTypeMenu("subscription")}/>
                            {translations && !isEmpty(translations["plans"])
                                ? translations["plans"]
                                : "Plans"
                            }
                        </h1>
                    </div>
                </div>
                <div className="content">
                    <h4>
                        {translations && !isEmpty(translations["your_subs"])
                            ? translations["your_subs"]
                            : "Your subscription"
                        }
                    </h4>
                    <div className="grid">
                        {customerPlan ? (
                            <div className="active-plan">
                                <div className="d-flex">
                                    <span className="badge" style={customerPlan.plan_active !== "1" ? {background: "red"} : {}}>
                                    {customerPlan.plan_active === "1" ? "Plan Actuel" : "Plan Not Active"}</span>
                                    <h2 className="my-auto mx-2">{!isEmpty(customerPlan?.product?.name) ? customerPlan.product.name : ""}</h2>
                                </div>
                                <div>
                                    <span className="price my-auto">{(customerPlan.unit_amount / 100).toLocaleString('eu-EU', {style: 'currency',currency: 'EUR'})} / {customerPlan.type === "recurring" ? customerPlan.recurring.interval : "one-time"}</span>
                                </div>
                                <div>
                                    <p className="my-auto">{!isEmpty(customerPlan?.product?.description) ? customerPlan.product?.description : ""}</p>
                                </div>
                            </div>

                        ) : (
                            <div className="active-plan">
                                You don't have an active subscribe.
                            </div>
                        )}
                    </div>
                </div>
                <div className="content">
                    <h4>
                        {translations && !isEmpty(translations["next_level"])
                            ? translations["next_level"]
                            : "Take it to the next level"
                        }
                    </h4>
                    <div className="subscription block">

                        {openModal && (
                            <PriceSelector
                                wait={wait}
                                prices={prices}
                                setCheckedPriceId={setCheckedPriceId}
                                closeModal={() => setOpenModal(!openModal)}
                                onChangePlan={onChangePlan}
                            />
                        )}

                        {openEditPayment && (
                            <EditPayment
                                onClose={() => setOpenEditPayment(!openEditPayment)}
                                onSuccess={onChangePlan}
                                setAsDefault={true}
                            />
                        )}

                        <div className="grid">
                            {products && products.map((product) => {
                                if (isEmpty(customerPlan) || (!isEmpty(customerPlan) && product.id !== customerPlan.product)) {
                                    return (
                                        <div className="element plans d-flex" key={product.id} id={product.id}>
                                            <div className="checkbox my-auto">
                                                <Checkbox
                                                    checked={checkedPlanId === product.id}
                                                    onChange={() => setCheckedPlanId((prev) => prev === product.id ? null : product.id)}
                                                    borderColor="#4f49a1"
                                                    borderWidth="1px"
                                                    containerClassName="d-block"
                                                    icon={
                                                        <svg fill="#4caf50" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                                                    }
                                                />
                                            </div>
                                            <div className="w-100 my-auto">
                                                <h2 className="my-2">{product.name}</h2>
                                                <p className="mb-2">{product.description}</p>
                                                <div className="">
                                                    {!isEmpty(product.prices) && product.prices.sort((a, b) => !isEmpty(b?.recurring?.interval) && !isEmpty(a?.recurring?.interval) ? a.recurring.interval < b.recurring.interval ? -1 : 0 : 0).map(price => {
                                                        return (
                                                            <Fragment key={price.id}>
                                                                <span key={price.id} className={`${price?.recurring?.interval} my-2`}>{(price.unit_amount / 100).toLocaleString('eu-EU', {style: 'currency',currency: 'EUR'})} / {!isEmpty(price?.recurring?.interval) ? price.recurring.interval : "one-time"}</span><br/>
                                                            </Fragment>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                } else {
                                    return false;
                                }

                            })}

                            <button
                                disabled={isEmpty(checkedPlanId)}
                                className="btn btn-stripe mt-2"
                                onClick={() => setOpenModal(!openModal)}
                                style={{background: !isEmpty(settings) ? settings.accent_color : ""}}
                            >Subscribe</button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default NavBarMobileSubscriptionPlans;
